import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { async } from 'rxjs/internal/scheduler/async';
import { SWAlertService } from '../../services/swalert.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
@Component({
  selector: 'app-recon-account',
  templateUrl: './recon-account.component.html',
  styleUrls: ['./recon-account.component.css']
})
export class ReconAccountComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private System: TSFuntionService, private SW: SWAlertService, private router: Router) { }
  ResultPermission: any = false;
  ResultPermissionMeun: any = true;

  ComNoResult: any;
  ReconAccountForm: FormGroup;
  get _ReconAccountForm() { return this.ReconAccountForm.controls; }
  get ReconAccount() { return this._ReconAccountForm.ReconAccount as FormArray; }
  arrRequestType: any;
  arrCompany: any;
  arrappover1: any = [];
  arrappover2: any = [];
  async ngOnInit() {
    this.SetForm();
    this.AutoComplete();
    await this.loadRequestType();
    this.setTable();
    let ObjData = {
      sRequestID: "",
      nMenuID: 16
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (this.ResultPermission) {
      this.ResultPermissionMeun = await this.System.CheckPermissionMeun(16);
      if (!this.ResultPermissionMeun) {
        this.ReconAccount.disable();
        this.ReconAccountForm.get('sComCode').disable();
      }
    }
  }
  async loadRequestType() {
    await this.http.get<any>(this.System.SiteName + "api/Autocomplete/TM_RequestType").toPromise().then(res => {
      this.arrRequestType = res.filter(f => f.IsActive == true)
    })
  }
  loadlstFlow() {
    this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_COMPANY_CODE").toPromise().then(res => {
    })
  }
  async AutoComplete() {
    //AutoComCode
    await this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_COMPANY_CODE").toPromise().then(res => {
      if (res) {
        this.arrCompany = res.filter(f => f.cActive == 'Y').map(m => ({ Company: m.COMPANY_CODE + " - " + m.COMPANY_NAME, COMPANY_CODE: m.COMPANY_CODE, COMPANY_NAME: m.COMPANY_NAME }))
      } else {

      }
    })
  }
  async CompanySelect(item) {

    let isHasAppover1: boolean = false;
    let isHasAppover2: boolean = false;
    let _this = this;
    this.arrRequestType.forEach(function (item, i) {
      _this.ReconAccount.at(i).get("sAppover1").markAsUntouched({ onlySelf: true });
      _this.ReconAccount.at(i).get("sAppover2").markAsUntouched({ onlySelf: true });
    })
    _this.ReconAccountForm.patchValue({ nComCode: item.item.COMPANY_CODE })
    await _this.http.get<any>(_this.System.SiteName + "api/Autocomplete/TUserPermission/*/sCompCode/" + item.item.COMPANY_CODE + "/nRole/3").toPromise().then(app1 => {
      if (app1) {
        isHasAppover1 = true
        _this.arrappover1 = app1.filter(f => f.cActive == "Y").map(m => ({ approver1: m.sName + " " + m.sSurName, nUserID: m.nUserID, sName: m.sName, sSurName: m.sSurName }));
      } else {
        isHasAppover1 = false;
      }
    })
    await _this.http.get<any>(_this.System.SiteName + "api/Autocomplete/TUserPermission/*/sCompCode/" + item.item.COMPANY_CODE + "/nRole/4").toPromise().then(app2 => {
      if (app2) {
        isHasAppover2 = true
        _this.arrappover2 = app2.filter(f => f.cActive == "Y").map(m => ({ approver2: m.sName + " " + m.sSurName, nUserID: m.nUserID, sName: m.sName, sSurName: m.sSurName }));
      } else {
        isHasAppover2 = false;
      }
    })
    _this.setTable();
    if (isHasAppover1 || isHasAppover2) {
      this.ReconAccount.controls.forEach(async function (data, index) {
        let nReqType = _this.arrRequestType.filter(f => f.nReqType == data.value.nReqTypeID)[0].nReqType;
        await _this.http.get<any>(_this.System.SiteName + "api/Autocomplete/TM_Flows/*/sCompCode/" + item.item.COMPANY_CODE + "/nReqType/" + nReqType + "").toPromise().then(res => {
          let Data = res
          if (Data != null) {
            let approver1 = _this.arrappover1.filter(f => f.nUserID == Data[0].nApproveID1)[0]
            let approver2 = _this.arrappover2.filter(f => f.nUserID == Data[0].nApproveID2)[0]
            Data[0].IsApprover_1 == true ? data.get("sAppover1").enable() : data.get("sAppover1").disable();
            Data[0].IsApprover_2 == true ? data.get("sAppover2").enable() : data.get("sAppover2").disable();
            data.patchValue({
              sComCode: item.item.COMPANY_CODE,
              cbAppover1: Data[0].IsApprover_1 == true ? true : false,
              cbAppover2: Data[0].IsApprover_2 == true ? true : false,
              sAppover1: Data[0].IsApprover_1 == true && isNullOrUndefined(approver1.approver1) != true ? approver1.approver1 : "",
              nAppoverID1: Data[0].IsApprover_1 == true && isNullOrUndefined(approver1) != true ? approver1.nUserID : null,
              sAppoverID1: Data[0].IsApprover_1 == true && isNullOrUndefined(approver1) != true ? approver1.nUserID : null,
              sAppover2: Data[0].IsApprover_2 == true && isNullOrUndefined(approver2) != true ? approver2.approver2 : "",
              nAppoverID2: Data[0].IsApprover_2 == true && isNullOrUndefined(approver2) != true ? approver2.nUserID : null,
              sAppoverID2: Data[0].IsApprover_2 == true && isNullOrUndefined(approver2) != true ? approver2.nUserID : null,
              IsActive: Data[0].cActive == "Y" ? true : false,
            })
          }
        })

      })
    } else {
      _this.setTable();
    }
  }
  cbAppover1(item, index) {
    if (item.target.checked == true) {
      this.ReconAccount.at(index).get("sAppover1").enable();
      this.ReconAccount.at(index).get("sAppover1").clearValidators();
      this.ReconAccount.at(index).get("sAppover1").setValidators(Validators.required);
      this.ReconAccount.at(index).get("sAppover1").setErrors(null);
      this.ReconAccount.at(index).get("sAppover1").markAsTouched({ onlySelf: true });
      this.ReconAccount.at(index).get("sAppover1").updateValueAndValidity();
    } else if (item.target.checked == false) {
      this.ReconAccount.at(index).get("sAppover1").disable();
      this.ReconAccount.at(index).get("sAppover1").clearValidators();
      this.ReconAccount.at(index).get("sAppover1").setValidators(null);
      this.ReconAccount.at(index).get("sAppover1").setErrors(null);
      this.ReconAccount.at(index).get("sAppover1").markAsUntouched({ onlySelf: true });
      this.ReconAccount.at(index).get("sAppover1").updateValueAndValidity();
      this.ReconAccount.at(index).patchValue({
        sAppover1: "",
        nAppoverID1: null,
      })

    }
  }
  cbAppover2(item, index) {
    if (item.target.checked == true) {
      this.ReconAccount.at(index).get("sAppover2").enable();
      this.ReconAccount.at(index).get("sAppover2").clearValidators();
      this.ReconAccount.at(index).get("sAppover2").setValidators(Validators.required);
      this.ReconAccount.at(index).get("sAppover2").setErrors(null);
      this.ReconAccount.at(index).get("sAppover2").markAsTouched({ onlySelf: true });
      this.ReconAccount.at(index).get("sAppover2").updateValueAndValidity();
    } else if (item.target.checked == false) {
      this.ReconAccount.at(index).get("sAppover2").disable();
      this.ReconAccount.at(index).get("sAppover2").clearValidators();
      this.ReconAccount.at(index).get("sAppover2").setValidators(null);
      this.ReconAccount.at(index).get("sAppover2").setErrors(null);
      this.ReconAccount.at(index).get("sAppover2").markAsUntouched({ onlySelf: true });
      this.ReconAccount.at(index).get("sAppover2").updateValueAndValidity();
      this.ReconAccount.at(index).patchValue({
        sAppover2: "",
        nAppoverID2: null,
      })
    }
  }
  onAppover1Select(item, index) {
    this.ReconAccount.at(index).patchValue({
      sAppover1: item.item.approver1,
      nAppoverID1: item.item.nUserID,
      sAppoverID1: item.item.nUserID
    })
  }
  onAppover2Select(item, index) {
    this.ReconAccount.at(index).patchValue({
      sAppover2: item.item.approver2,
      nAppoverID2: item.item.nUserID,
      sAppoverID2: item.item.nUserID
    })
  }
  IsActiveSelect(item, index) {
    this.ReconAccount.at(index).get('IsActive').patchValue(item.target.value == "true" ? true : false)
  }
  Save() {
    let _this = this;
    let arrData: Array<any> = [];
    let isPass = true;
    let validate = ["sAppover1", "sAppover2"]
    for (var i = 0; i < this.ReconAccount.length; i++) {
      validate.forEach(function (field) {
        if (!_this.ReconAccount.at(i).get(field).valid && _this.ReconAccount.at(i).get(field).disabled != true) {
          isPass = false;
        }
      })
    }
    if (isPass && this.ReconAccountForm.get('nComCode').value != "") {
      let comcode = this.ReconAccountForm.get('nComCode').value;
      this.ReconAccount.controls.forEach(function (item, i) {
        let obj = {};
        obj["sComCode"] = comcode;
        obj["nReqType"] = item.value.nReqTypeID;
        obj["IsApprover_1"] = item.value.cbAppover1 == true ? true : false;
        obj["IsApprover_2"] = item.value.cbAppover2 == true ? true : false;
        obj["nApproveID1"] = +item.value.sAppoverID1;
        obj["nApproveID2"] = +item.value.sAppoverID2;
        obj["cActive"] = item.value.IsActive == true ? true : false;
        arrData.push(obj);
      })
      let Save = function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let Data = JSON.stringify(arrData)
        _this.http.post(_this.System.SiteName + "api/ReconAccount/Save", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { });
            _this.ReconAccountForm.patchValue({ sComCode: "", nComCode: "" })
            _this.setTable();
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, Save, function () { });
    } else {
      for (var i = 0; i < this.ReconAccount.length; i++) {
        validate.forEach(function (field) {
          if (!_this.ReconAccount.at(i).get(field).valid && _this.ReconAccount.at(i).get(field).disabled != true) {
            _this.ReconAccount.at(i).get(field).markAsTouched({ onlySelf: true })
          }
        })
      }
    }
  }
  Back() {
    this.router.navigate(['/home'])
  }
  setTable() {
    let _this = this;
    this.ReconAccount.clear();
    this._ReconAccountForm.ReconAccount.reset();
    let num = 0;
    this.arrRequestType.forEach(function (item, i) {
      _this.ReconAccount.push(new FormGroup({
        sComCode: new FormControl(''),
        nReqType: new FormControl(''),
        nReqTypeID: new FormControl(''),
        cbAppover1: new FormControl(''),
        sAppover1: new FormControl('', Validators.required),
        nAppoverID1: new FormControl(''),
        sAppoverID1: new FormControl(''),
        cbAppover2: new FormControl(''),
        sAppover2: new FormControl('', Validators.required),
        nAppoverID2: new FormControl(''),
        sAppoverID2: new FormControl(''),
        IsActive: new FormControl('false')
      }))
      _this.ReconAccount.at(num).patchValue({
        nReqType: item.sReqType,
        nReqTypeID: item.nReqType
      })
      _this.ReconAccount.at(num).get('sAppover1').disable();
      _this.ReconAccount.at(num).get('sAppover2').disable();
      num++;
    })
  }
  SetForm() {
    this.ReconAccountForm = this.formBuilder.group({
      sComCode: [""],
      nComCode: "",
      ReconAccount: new FormArray([
        new FormGroup({
          sComCode: new FormControl(''),
          nReqTypeID: new FormControl(''),
          nReqType: new FormControl(''),
          cbAppover1: new FormControl(''),
          sAppover1: new FormControl('', Validators.required),
          nAppoverID1: new FormControl(''),
          sAppoverID1: new FormControl(''),
          cbAppover2: new FormControl(''),
          sAppover2: new FormControl('', Validators.required),
          nAppoverID2: new FormControl(''),
          sAppoverID2: new FormControl(''),
          IsActive: new FormControl('false')
        })
      ]),
    });
  }
  ComNoResults(event: boolean): void {
    this.ComNoResult = event;
  }
  ComOnBlur() {
    if (this.ComNoResult) {
      this.ReconAccountForm.patchValue({
        sComCode: "",
        nComCode: "",
      });
      this.setTable();
    }
  }
  isFieldValid(_Field: string, _inx) {
    let FromArray = this.ReconAccount as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCss(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValid(_Field, _inx),
      'has-feedback': this.isFieldValid(_Field, _inx)
    };
  }
}
